var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import Button from '../../Buttons/Button/Button';
import Typography from '../../Styles/Typography/Typography';
import Box from '../../Layout/Flex/Box';
import IconButton from '../../Buttons/IconButton/IconButton';
import Spacer from '../../Layout/Spacer/Spacer';
import Skeleton from '../../Progress/Skeleton/Skeleton';
const PaginatedContainer = styled.div `
  margin-top: ${props => props.marginTop ? props.marginTop : props.theme.paddingsMargins.themeMenuMarginSingle};
  margin-bottom: ${props => props.marginTop ? props.marginBottom : props.theme.paddingsMargins.themeMenuMarginSingle};
`;
const PaginatedTab = (_a) => {
    var { page, numPages, isLoading = false, elemsTotal = 0, numberOfPagesOffset = 4, totalText = 'Companies found', resultText = 'Page', marginTop, isHideLastPageClick, marginBottom, title, isDisabled = false, goTop = false, secondary = false, isOnlyPagination = false, isPrevNext = false, prevNextLabels = { prev: '', next: '' }, getCurrentPage, onChangePage, children } = _a, props = __rest(_a, ["page", "numPages", "isLoading", "elemsTotal", "numberOfPagesOffset", "totalText", "resultText", "marginTop", "isHideLastPageClick", "marginBottom", "title", "isDisabled", "goTop", "secondary", "isOnlyPagination", "isPrevNext", "prevNextLabels", "getCurrentPage", "onChangePage", "children"]);
    const scrollTo = useRef(null);
    const [currPage, setCurrPage] = useState(page);
    useEffect(() => {
        if (getCurrentPage) {
            getCurrentPage(currPage);
        }
        ;
    }, [currPage, getCurrentPage]);
    useEffect(() => {
        setCurrPage(page);
    }, [page]);
    const firstUpdatePagination = useRef(true);
    useEffect(() => {
        if (firstUpdatePagination.current) {
            firstUpdatePagination.current = false;
        }
        else {
            if (onChangePage) {
                onChangePage(currPage);
            }
            ;
        }
    }, [currPage]);
    const handleButton = (value) => {
        if (!isDisabled) {
            if (value === 'next') {
                setCurrPage(currPage + 1);
            }
            else
                setCurrPage(currPage - 1);
            if (goTop && scrollTo.current !== null) {
                scrollTo.current.scrollIntoView(goTop);
            }
        }
    };
    const generatePreviousArray = () => {
        const previousArray = [];
        if (!isPrevNext) {
            for (let i = currPage - 1; i >= (currPage - numberOfPagesOffset); --i) {
                if (i >= 1) {
                    previousArray.push(_jsx(Button, { text: i.toString(), onClick: () => { setCurrPage(i); }, secondary: secondary, size: "subArticle", noMargin: true, noBorder: true, isDisabled: isDisabled }, i));
                }
            }
        }
        return previousArray;
    };
    const generateNextArray = () => {
        const nextArray = [];
        if (!isPrevNext) {
            for (let i = currPage + 1; i <= (currPage + numberOfPagesOffset > numPages ? numPages : currPage + numberOfPagesOffset); i++) {
                nextArray.push(_jsx(Button, { text: i.toString(), onClick: () => { setCurrPage(i); }, secondary: secondary, size: "subArticle", noMargin: true, noBorder: true, isDisabled: isDisabled }, i));
            }
        }
        return nextArray;
    };
    return (_jsxs(PaginatedContainer, Object.assign({ marginTop: marginTop, marginBottom: marginBottom, ref: scrollTo }, props, { children: [!isOnlyPagination &&
                _jsxs(Fragment, { children: [title &&
                            _jsxs(Fragment, { children: [_jsx(Typography, Object.assign({ size: "article", color: secondary ? 'secondary' : 'main' }, { children: title })), _jsx(Spacer, { vertical: true, half: true })] }), _jsx(Box, Object.assign({ column: true }, { children: children })), _jsx(Spacer, { vertical: true, half: true }), _jsx(Typography, Object.assign({ color: secondary ? 'secondary' : 'main', size: "subArticle" }, { children: `${totalText}: ${elemsTotal}` })), _jsx(Spacer, { vertical: true, half: true })] }), _jsxs(Box, Object.assign({ alignItems: "center", justifyContent: isPrevNext ? 'space-between' : 'flex-start' }, { children: [isPrevNext
                        ? _jsx(Button, { size: "button", text: prevNextLabels.prev, icon: { icon: 'arrowLeft', position: 'left' }, color: secondary ? 'secondary' : 'main', isDisabled: currPage === 1 || isLoading || isDisabled, onClick: () => handleButton('prev'), noMargin: true })
                        : _jsx(IconButton, { icon: "arrowLeft", size: "article", color: secondary ? 'secondary' : 'main', isDisabled: currPage === 1 || isLoading || isDisabled, onClick: () => handleButton('prev') }), _jsx(Spacer, { half: true }), isLoading
                        ? _jsxs(_Fragment, { children: [_jsx(Skeleton, { width: "article", height: "subTitle", margin: "0px 10px 0px 0px" }), _jsx(Skeleton, { width: "article", height: "subTitle", margin: "0px 10px 0px 0px" }), _jsx(Skeleton, { width: "article", height: "subTitle", margin: "0px 10px 0px 0px" }), _jsx(Skeleton, { width: "article", height: "subTitle", margin: "0px 0px 0px 0px" })] })
                        : !isPrevNext &&
                            _jsxs(Fragment, { children: [currPage >= numberOfPagesOffset + 2 &&
                                        _jsx(Box, { children: _jsx(Button, { size: "subArticle", secondary: secondary, text: "1...", onClick: () => setCurrPage(1), noBorder: true, noMargin: true, isDisabled: isDisabled }) }), generatePreviousArray()
                                        .splice(0, numberOfPagesOffset)
                                        .reverse()
                                        .map(value => { return value; }), _jsx(Button, { text: currPage.toString(), size: "subArticle", secondary: secondary, noMargin: true }), generateNextArray().splice(0, numberOfPagesOffset).map(value => {
                                        return value;
                                    }), (!isHideLastPageClick && (currPage < numPages - numberOfPagesOffset)) &&
                                        _jsx(Box, { children: _jsx(Button, { size: "subArticle", secondary: secondary, text: '... ' + numPages, onClick: () => setCurrPage(numPages), noBorder: true, noMargin: true, isDisabled: isDisabled }) })] }), _jsx(Spacer, { half: true }), isPrevNext
                        ? _jsx(Button, { size: "button", text: prevNextLabels.next, icon: { icon: 'arrowRight', position: 'right' }, color: secondary ? 'secondary' : 'main', isDisabled: currPage === numPages || isLoading || isDisabled, onClick: () => handleButton('next'), noMargin: true })
                        : _jsx(IconButton, { icon: "arrowRight", size: "article", color: secondary ? 'secondary' : 'main', isDisabled: currPage === numPages || isLoading || isDisabled, onClick: () => handleButton('next') }), !isPrevNext && _jsx(Spacer, { half: true }), !isLoading && numPages && !isPrevNext && _jsxs(Typography, Object.assign({ size: "subArticle", color: secondary ? 'secondary' : 'main' }, { children: [resultText, " ", currPage, " / ", numPages] }))] }))] })));
};
export default PaginatedTab;
